import { render } from "./SchoolConfirmation.vue?vue&type=template&id=6d2f96b2&scoped=true&ts=true"
import script from "./SchoolConfirmation.vue?vue&type=script&lang=ts"
export * from "./SchoolConfirmation.vue?vue&type=script&lang=ts"

import "./SchoolConfirmation.vue?vue&type=style&index=0&id=6d2f96b2&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2f96b2"]])

export default __exports__